
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";
// import Navbar from "@/components/Utility/Navbar.vue";
// import Footer from "@/components/Utility/Footer.vue";
import Carousel from "@/components/Home/Carousel.vue";
import MobileSwiper from "@/components/Home/MobileSwiper.vue";
import CountUpNumber from "@/components/Utility/CountUpNumber.vue";
import ReviewsMarquee from "@/components/Home/ReviewsMarquee.vue";
import SitePromoBanner from "@/components/Utility/SitePromoBanner.vue";

@Component({
  components: {
    // Navbar,
    // Footer,
    Carousel,
    MobileSwiper,
    CountUpNumber,
    ReviewsMarquee,
    SitePromoBanner,
  },
})
export default class Home extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: "師虎來了 Tiger Master｜台灣本土第一居家修繕媒合平台",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "師虎來了是台灣本土第一居家修繕媒合平台，提供抓漏、水電、裝潢修繕、清潔等八大類到府服務。師傅皆通過面試審核，工程款採 3 成訂金、7 成驗收滿意再付款，讓找師傅不再靠運氣。",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "師虎來了 Tiger Master｜台灣本土第一居家修繕媒合平台",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "師虎來了是台灣本土第一居家修繕媒合平台，提供抓漏、水電、裝潢修繕、清潔等八大類到府服務。師傅皆通過面試審核，工程款採 3 成訂金、7 成驗收滿意再付款，讓找師傅不再靠運氣。",
        },
      ],
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: "https://www.fdtigermaster.com/",
        },
      ],
      script: [
        {
          vmid: "ld-json-organization",
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "師虎來了",
            alternateName: ["Tiger Master", "飛達智能股份有限公司"],
            legalName: "飛達智能股份有限公司",
            url: "https://www.fdtigermaster.com/",
            logo: "https://www.fdtigermaster.com/fdtiger-offical-site-img/logo.png",
            description:
              "台灣本土第一居家修繕媒合平台，提供水電、裝潢修繕、清潔、病媒防治等修繕服務。",
            sameAs: [
              "https://www.facebook.com/FDTigerMaster/",
              "https://apps.apple.com/tw/app/%E5%B8%AB%E8%99%8E%E4%BE%86%E4%BA%86/id1495518547",
              "https://play.google.com/store/apps/details?id=app.viuto.www.tiger_master&hl=zh_TW&gl=US",
            ],
          },
        },
      ],
    };
  }

  //data
  isPaymentNoteHighlightRevealed = false;
  private paymentNoteHighlightObserver: IntersectionObserver | null = null;
  private fiveStepRevealObserver: IntersectionObserver | null = null;

  statsList = [
    { target: 25000, suffix: "+", label: "完成修繕交易" },
    { target: 220000, suffix: "+", label: "平台會員" },
    { target: 2200, suffix: "+", label: "合作師傅" },
  ];
  bizServices = [
    {
      icon: require("../assets/icon/Headset.svg"),
      title: "施工協助",
      desc: "施工問題有人協助，有問題直接找師虎來了，不必自行與師傅周旋。",
    },
    {
      icon: require("../assets/icon/ShieldCheck.svg"),
      title: "售後保固",
      desc: "保固問題直接找平台，無須擔心聯絡不到原施工師傅。",
    },
    {
      icon: require("../assets/icon/LockKey.svg"),
      title: "付款保障",
      desc: "工程款由平台管理，每筆付款都有紀錄，不需要私下支付工程款。",
    },
    {
      icon: require("../assets/icon/Receipt.svg"),
      title: "發票憑證",
      desc: "發票由師虎來了開立，付款資訊透明，報帳也更方便。",
    },
  ];
  bizTableRows = [
    {
      label: "媒合速度",
      ours: "系統快速比對\n最快當天媒合到適合的師傅",
      general: "派工快，但不一定符合需求",
      others: "需自行上網比價、逐一詢問\n耗時費力",
    },
    {
      label: "付款方式",
      ours: "3 成訂金\n7 成驗收滿意再付款",
      general: "媒合後由雙方自行議定付款方式",
      others: "常需先付大筆工程款",
    },
    {
      label: "施工遇到問題",
      ours: "平台專人協助處理協調",
      general: "多半只負責媒合\n後續需自行溝通",
      others: "自己和師傅周旋",
    },
    {
      label: "保固服務",
      ours: "直接找師虎來了",
      general: "保固需自行與師傅約定",
      others: "師傅可能已聯絡不上",
    },
    {
      label: "交易安全",
      ours: "款項由平台管理\n不需私下付款",
      general: "款項多為私下交付\n平台不參與保管",
      others: "現金交付陌生師傅",
    },
    {
      label: "發票",
      ours: "由師虎來了統一開立",
      general: "是否開立依師傅而定",
      others: "不一定有發票",
    },
  ];
  clickL1 = [
    {
      name: "安裝服務",
      img: "fdtiger-offical-site-img/home/service_01.jpg",
      index: 0,
    },
    {
      name: "水電服務",
      img: "fdtiger-offical-site-img/home/service_02.jpg",
      index: 1,
    },
    {
      name: "清潔服務",
      img: "fdtiger-offical-site-img/home/service_03.jpg",
      index: 2,
    },
    {
      name: "裝潢整修",
      img: "fdtiger-offical-site-img/home/service_04.jpg",
      index: 3,
    },
    {
      name: "搬運服務",
      img: "fdtiger-offical-site-img/home/service_05.jpg",
      index: 4,
    },
    {
      name: "家電服務",
      img: "fdtiger-offical-site-img/home/service_06.jpg",
      index: 5,
    },
    {
      name: "房屋漏水",
      img: "fdtiger-offical-site-img/home/service_07.jpg",
      index: 6,
    },
    {
      name: "消毒病媒",
      img: "fdtiger-offical-site-img/home/service_08.jpg",
      index: 7,
    },
  ];
  device = 0;
  // 同上方模板註解：清單依原型稿原樣保留，含未確認/疑似投資人名稱，待人工確認後修正，不自行調整。
  welfarePartners = [
    {
      name: "統一證券",
      logo: "/fdtiger-offical-site-img/home/welfare-logo-president-securities.jpg",
    },
    {
      name: "崇越科技",
      logo: "/fdtiger-offical-site-img/home/welfare-logo-topco.jpg",
    },
    {
      name: "英濟科技",
      logo: "/fdtiger-offical-site-img/home/welfare-logo-megaforce.jpg",
    },
    {
      name: "中華電信職工福委會",
      logo: "/fdtiger-offical-site-img/home/welfare-logo-chunghwa-telecom-welfare.jpg",
    },
    {
      name: "遠傳電信",
      logo: "/fdtiger-offical-site-img/home/welfare-logo-fetnet.jpg",
    },
  ];

  private setupPaymentNoteHighlight(): void {
    const highlight = this.$refs.paymentNoteHighlight as HTMLElement | undefined;

    if (!highlight) return;

    if (typeof IntersectionObserver === "undefined") {
      this.isPaymentNoteHighlightRevealed = true;
      return;
    }

    this.paymentNoteHighlightObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry?.isIntersecting) return;

        this.isPaymentNoteHighlightRevealed = true;
        this.paymentNoteHighlightObserver?.unobserve(entry.target);
        this.paymentNoteHighlightObserver?.disconnect();
        this.paymentNoteHighlightObserver = null;
      },
      {
        threshold: 0.45,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    this.paymentNoteHighlightObserver.observe(highlight);
  }

  private setupFiveStepReveal(): void {
    if (typeof IntersectionObserver === "undefined") return;

    const mediaItems = Array.from(
      (this.$el as HTMLElement).querySelectorAll<HTMLElement>(
        ".five-step-media-motion"
      )
    );

    if (!mediaItems.length) return;

    this.fiveStepRevealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const media = entry.target as HTMLElement;
          media.classList.remove("is-reveal-pending");
          this.fiveStepRevealObserver?.unobserve(media);
        });
      },
      {
        threshold: 0.24,
        rootMargin: "0px 0px -18% 0px",
      }
    );

    mediaItems.forEach((media) => {
      media.classList.add("is-reveal-pending");
      this.fiveStepRevealObserver?.observe(media);
    });
  }

  mounted(): void {
    this.setupPaymentNoteHighlight();
    this.setupFiveStepReveal();
  }

  beforeDestroy(): void {
    this.paymentNoteHighlightObserver?.disconnect();
    this.paymentNoteHighlightObserver = null;
    this.fiveStepRevealObserver?.disconnect();
    this.fiveStepRevealObserver = null;
  }
}
